import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App/App";
import { Auth0Provider } from "@auth0/auth0-react";
import { Provider } from "react-redux";
import { store, persistor } from "./App/State/Store";

import { PersistGate } from "redux-persist/integration/react";
import { StyledEngineProvider } from "@mui/material";
import { QueryProvider } from "./App/Helpers/queryProvider";
import { withLDProvider } from "launchdarkly-react-client-sdk";

const FeatureToggleProvider = withLDProvider({
  clientSideID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENTID,
  options: {
    streaming: true,
  },
})(AuthApp);

function AuthApp() {
  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENTID}
      redirectUri={window.location.origin}
      audience={import.meta.env.VITE_AUTH0_AUDIENCE}
      cacheLocation={window.parent.Cypress ? "localstorage" : "memory"}
    >
      <StyledEngineProvider injectFirst>
        <Provider store={store}>
          <QueryProvider>
            <PersistGate loading={null} persistor={persistor}>
              <App />
            </PersistGate>
          </QueryProvider>
        </Provider>
      </StyledEngineProvider>
    </Auth0Provider>
  );
}

ReactDOM.render(<FeatureToggleProvider />, document.getElementById("root"));

